/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.authModule')
  .controller('SignUpController', [
    '$cookies',
    '$http',
    '$log',
    '$scope',
    '$state',
    '$stateParams',
    '$timeout',
    '$translate',
    '$window',
    'google',
    'moment',
    'Restangular',
    'BulbAjaxService',
    'BulbBrowserService',
    'BulbBusyService',
    'BulbCoppaModalService',
    'BulbErrorService',
    'BulbModalService',
    'AeroDialogService',
    'RecordEventService',
    'CONFIG',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    SignUpController,
  ]);

function SignUpController(
  $cookies,
  $http,
  $log,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $translate,
  $window,
  google,
  moment,
  Restangular,
  BulbAjaxService,
  BulbBrowserService,
  BulbBusyService,
  BulbCoppaModalService,
  BulbErrorService,
  BulbModalService,
  AeroDialogService,
  RecordEventService,
  CONFIG,
) {
  const that = this;
  const incompleteSignupEndpoint = '/b/rest/accounts/incomplete-signup';

  // Attach the CONFIG to this current scope:
  $scope.CONFIG = CONFIG;

  const MINIMUM_AGE_YEARS = CONFIG.minimumAgeYears;
  this.devToolsEnabled = process.env.DEVTOOLS_ENABLED;
  this.bootstrapEnabled = process.env.BOOTSTRAP_ENABLED;
  this.cleverIntegrationEnabled = CONFIG.features.cleverIntegrationEnabled;

  this.isMobile = BulbBrowserService.isMobile();
  this.mode = $stateParams.mode;
  this.subscribeMode = $stateParams.subscribeMode;
  if ($stateParams.redirected) {
    this.redirected = $stateParams.redirected;
  } else {
    this.redirected = false;
  }
  this.signInUnsuccessful = false;
  this.organizationConnectionToken = $stateParams.orgToken;
  this.form = {
    prepaidCode: $stateParams.prepaidCode,
  };

  // If we are on the exp sign-up page.
  this.exp = $stateParams.exp || $cookies.get('expSignup');

  this.isDobValid = true;
  this.marketingOptIn = false;
  this.googleSignInReady = false;
  this.submitAttempted = false;
  this.incompleteSignupSent = false;

  this.countries = [];

  this.grade = $stateParams.grade;
  // Only translating Higher Education and Other for now and re-using position's key for 'Other'.
  this.grades = [{ value: 'PRESCHOOL', display: 'Pre-K' }, { value: 'KINDERGARTEN', display: 'K' },
    { value: 'FIRST', display: '1' }, { value: 'SECOND', display: '2' }, { value: 'THIRD', display: '3' },
    { value: 'FOURTH', display: '4' }, { value: 'FIFTH', display: '5' }, { value: 'SIXTH', display: '6' },
    { value: 'SEVENTH', display: '7' }, { value: 'EIGHTH', display: '8' }, { value: 'NINTH', display: '9' },
    { value: 'TENTH', display: '10' }, { value: 'ELEVENTH', display: '11' }, { value: 'TWELFTH', display: '12' },
    { value: 'POSTGRADUATE', display: $translate.instant('grade_level_POSTGRADUATE') },
    { value: 'OTHER', display: $translate.instant('sign_up_bulb_position_other') }];

  if (process.env.DEVTOOLS_ENABLED) {
    this.isTestTrial = false;
  }

  this.dateOptions = {
    dateFormat: 'm/d/Y',
    maxDate: 'today',
    allowInput: true,
    onOpen: [function dateOptionsOnOpen(/* selectedDates, dateStr, instance */) {
      $('#dobWrapper').toggleClass('close');
    }],
    onClose: [function dateOptionsOnClose(/* selectedDates, dateStr, instance */) {
      $('#dobWrapper').toggleClass('close');
    }],
  };

  this.$onInit = function onInit() {
    fetchCountries();

    // If this is on the exp page, set default language to PT, update order of positions, set default position to
    // OTHER, set the orgToken to the exp org, and sets a cookie expSignup so when a user gets routed back from an OAuth
    // signup we continue to track it.
    if (this.exp) {
      $translate.use('pt');
      $cookies.put('language', 'pt', {
        secure: true,
        samesite: 'None',
      });

      const current = new Date();
      const expiresValue = new Date(current);
      expiresValue.setMinutes(current.getMinutes() + 5);

      $cookies.put('expSignup', 'true', {
        secure: true,
        samesite: 'None',
        expires: expiresValue,
      });

      this.organizationConnectionToken = 'AXYGAM';

      this.positions = [
        {
          value: 'Other',
          display: 'sign_up_bulb_position_other',
        }, {
          value: 'Student',
          display: 'sign_up_bulb_position_student',
        }, {
          value: 'Professional',
          display: 'sign_up_bulb_position_professional',
        }, {
          value: 'Educator',
          display: 'sign_up_bulb_position_educator',
        }, {
          value: 'FamilyMember',
          display: 'sign_up_bulb_position_parent_guardian',
        }, {
          value: 'Administrator',
          display: 'sign_up_bulb_position_administrator',
        },
      ];

      this.form.position = 'Other';
    }

    // Hacky solution for making a <script> tag dynamic in angular.
    // See https://stackoverflow.com/questions/34489916/how-to-load-external-scripts-dynamically-in-angular
    // Needs to be dynamic for translating.
    if (CONFIG.reCaptcha.enabled) {
      const node = document.createElement('script');
      node.src = `https://www.recaptcha.net/recaptcha/api.js?hl=${$translate.getLanguage()}`;
      node.async = true;
      node.defer = true;
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  };

  function fetchCountries() {
    let lang = navigator.language;
    if (lang.includes('-')) {
      const langs = lang.split('-');
      lang = `${langs[0]}_${langs[1].toUpperCase()}`;
    }

    const request = {
      method: 'get',
      url: `https://assets.bulbapp.com/countries/${lang}`,
      dataType: 'json',
      contentType: 'application/json',
    };

    $http(request).success((fetchedCountries) => {
      that.countries = fetchedCountries;
    });
  }

  /**
   * Handle setting the correct position on the sign-up from our angular aero dropdown component.
   *
   * @param event
   */
  this.handleSettingFormPosition = function handleSettingFormPosition(event) {
    this.form.position = event.selectedOption;
  };

  /**
   * Handle setting the correct country on the sign-up from our angular aero dropdown component.
   *
   * @param event
   */
  this.handleSettingFormCountry = function handleSettingFormCountry(event) {
    this.form.country = event.selectedOption;
  };

  /**
   * Handle setting the grade on the sign-up from our angular aero dropdown component.
   *
   * @param event
   */
  this.handleSettingFormGrade = function handleSettingFormGrade(event) {
    this.form.grade = event.selectedOption;
  };

  /**
   * Function that redirects user to the sign-in page.
   */
  this.redirectToSignIn = function redirectToSignIn(event) {
    if (event.type === 'click') {
      $state.go('signIn');
    } else if (event.key === 'Enter' || event.key === ' ') {
      $state.go('signIn', { redirected: true });
    }
  };

  this.isCleverStudent = (this.mode === 'connectClever' || this.mode === 'signUpClever')
                && $stateParams.position === 'Student';

  // Boolean to check if our app is running as a hosted webapp, PWA.
  this.runningInPWAEnvironment = BulbBrowserService.isPWAEnvironment();

  // Load the gapi auth2
  if (google.load) {
    google.load('auth2', () => {
      that.googleSignInReady = true;
    });
  }

  // This is the group of positions that we have to require a school district for.
  this.requireInstitutionFor = ['Educator', 'Administrator', 'Other'];

  if (process.env.COPPA_VERIFICATION_REQUIRED) {
    this.showCOPPADateValidationModal = function showCOPPADateValidationModal() {
      return BulbModalService.show({
        titleCode: 'coppa_date_validation_alert_title',
        bodyCode: 'coppa_date_validation_alert_body',
        showCancelButton: false,
        showOkButton: false,
        closeOnClick: false,
      });
    };

    this.underAgedUserCheck = function underAgedUserCheck(date) {
      const dateNow = moment();
      const todayMinusThirteenYears = dateNow.subtract(MINIMUM_AGE_YEARS, 'years').valueOf();
      if (+date >= +todayMinusThirteenYears) {
        that.showCOPPADateValidationModal();
      }
      that.inputDateInMillis = date;
    };

    /**
     * Handle key down event for date picker. In case of enter key, validate the entered date.
     *
     * @param event KeyboardEvent triggered
     */
    this.handleDatePickerKeyDownEvent = function handleDatePickerKeyDownEvent(event) {
      if (event.key === 'Enter' || event.key === 'Tab') {
        that.form.dateOfBirth = event.target.value;
        const isValidDate = that.validateDateOfBirth();
        // If date is not valid, we don't want the event to pass to picker library.
        if (!isValidDate) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    };

    this.validateDateOfBirth = function validateDateOfBirth() {
      let dateToValidate;
      const validDateFormats = ['MM/DD/YYYY'];
      const dateValidationRegex = new RegExp(
        '^(0?[1-9]|1[012])\\/(0?[1-9]|[12][0-9]|3[01])\\/((19\\d{2})|([2-9]\\d{3}))$',
      );

      // Set the touched state of dob field to true.
      that.signUpForm.dateOfBirth.$touched = true;

      that.isDobValid = true;
      // check to see if the date input is a valid length
      if (that.form.dateOfBirth.match(dateValidationRegex)) {
        dateToValidate = moment(that.form.dateOfBirth, validDateFormats, true);
        if (dateToValidate) {
          const dateAsString = `${dateToValidate.month() + 1}/${dateToValidate.date()}/${dateToValidate.year()}`;

          // We run the date against a regex of valid dates to make sure the date is after 1900, etc. This way the user
          // cannot enter something like 11/11/1111 as a DOB which would be considered valid without this check.
          const match = dateAsString.match(dateValidationRegex);

          that.isDobValid = dateToValidate.isBefore(moment() - 94670778000);

          // Take date input of valid length and check to see if it's actually valid, i.e. 02/30 should be false.
          // This also checks for a date that indicates the DOB is 3 years old or more or in the future.
          if (match && dateToValidate.isValid() && that.isDobValid) {
            that.signUpForm.dateOfBirth.$setValidity('dateOfBirth', true);
            that.underAgedUserCheck(dateToValidate.valueOf());
            return true;
          }
        }
      }

      that.signUpForm.dateOfBirth.$setValidity('dateOfBirth', false);
      return false;
    };
  }

  this.goBack = function goBack() {
    switch (this.mode) {
      case 'connectGoogle':
        this.goSignUpGoogle();
        break;
      case 'connectMicrosoft':
        this.goSignUpMicrosoft();
        break;
      case 'connectClever':
        this.goSignUpClever();
        break;
      case 'connectClassLink':
        this.goSignUpClassLink();
        break;
      default:
        this.form = {
          prepaidCode: $stateParams.prepaidCode,
        };
        this.mode = 'default';
        break;
    }
  };

  that.positions = [{
    value: 'Educator',
    display: 'sign_up_bulb_position_educator',
  }, {
    value: 'Student',
    display: 'sign_up_bulb_position_student',
  }, {
    value: 'Administrator',
    display: 'sign_up_bulb_position_administrator',
  }, {
    value: 'FamilyMember',
    display: 'sign_up_bulb_position_parent_guardian',
  }, {
    value: 'Professional',
    display: 'sign_up_bulb_position_professional',
  }, {
    value: 'Other',
    display: 'sign_up_bulb_position_other',
  }];

  // Set the role/position if it is already provided
  if (['Educator', 'Student', 'Administrator', 'FamilyMember', 'Other'].indexOf($stateParams.position) !== -1) {
    that.form.position = $stateParams.position;
    that.positionDisabled = true;
  }

  /* jshint ignore:end */

  this.goConnectGoogle = function goConnectGoogle() {
    this.form = {
      prepaidCode: $stateParams.prepaidCode,
      email: $stateParams.email,
    };
    this.mode = 'connectGoogle';
  };

  this.goConnectMicrosoft = function goConnectMicrosoft() {
    this.form = {
      prepaidCode: $stateParams.prepaidCode,
      uniqueName: $stateParams.uniqueName,
      email: $stateParams.email,
    };
    this.mode = 'connectMicrosoft';
  };

  this.goConnectClever = function goConnectClever() {
    this.form = {
      prepaidCode: $stateParams.prepaidCode,
      uniqueName: $stateParams.uniqueName,
    };
    this.mode = 'connectClever';
  };

  /**
   * Connect With ClassLink & Sign In With Existing Account
   */
  this.goConnectClassLink = function goConnectClassLink() {
    this.form = {
      prepaidCode: $stateParams.prepaidCode,
      uniqueName: $stateParams.uniqueName,
    };
    this.mode = 'connectClassLink';
  };

  this.goSignUpGoogle = function goSignUpGoogle() {
    this.form = {
      prepaidCode: $stateParams.prepaidCode,
      email: $stateParams.email,
    };
    this.mode = 'signUpGoogle';
  };

  this.goSignUpMicrosoft = function goSignUpMicrosoft() {
    this.form = {
      prepaidCode: $stateParams.prepaidCode,
      uniqueName: $stateParams.uniqueName,
      email: $stateParams.email,
    };
    this.mode = 'signUpMicrosoft';
  };

  this.goSignUpClever = function goSignUpClever() {
    this.form = {
      prepaidCode: $stateParams.prepaidCode,
      uniqueName: $stateParams.uniqueName,
      email: $stateParams.email,
    };
    this.mode = 'signUpClever';
  };

  /**
   * SignUp With ClassLink & Create a New Account
   */
  this.goSignUpClassLink = function goSignUpClassLink() {
    this.form = {
      prepaidCode: $stateParams.prepaidCode,
      uniqueName: $stateParams.uniqueName,
      email: $stateParams.email,
    };
    this.mode = 'signUpClassLink';
  };

  // Make sure we are displaying the correct info for the incoming mode
  switch (this.mode) {
    case 'connectGoogle':
      this.goConnectGoogle();
      break;
    case 'connectMicrosoft':
      this.goConnectMicrosoft();
      break;
    case 'connectClever':
      this.goConnectClever();
      break;
    case 'connectClassLink':
      this.goConnectClassLink();
      break;
    case 'signUpGoogle':
      this.goSignUpGoogle();
      break;
    case 'signUpMicrosoft':
      this.goSignUpMicrosoft();
      break;
    case 'signUpClever':
      this.goSignUpClever();
      break;
    case 'signUpClassLink':
      this.goSignUpClassLink();
      break;
  }

  this.handleSuccessfulSignUp = function handleSuccessfulSignUp(account, newAccount) {
    if (!account.enabled && !that.form.prepaidCode) {
      BulbCoppaModalService.showCOPPAactionModal();
    } else if (newAccount) {
      if (that.organizationConnectionToken) {
        Restangular.all(`token/member/${that.organizationConnectionToken}`)
          .post()
          .then((updatedAccount) => {
            // If a target url is provided, use it.  Otherwise, load the user's profile page and display
            // the welcome.
            if ($stateParams.targetUrl) {
              $state.go('successfulSignup', {
                setStorage: true,
                reloadUrl: $stateParams.targetUrl,
                referrer: $stateParams.referrer,
              });
            } else if (updatedAccount.bulbSchoolDirectMemberships > 0) {
              $state.go('successfulSignup', { reloadUrl: '/b/account/billing/NEW' });
            } else {
              let reloadUrl = `/${updatedAccount.username}?welcome`;
              if (updatedAccount.email) {
                reloadUrl += '&verifyEmail';
              }
              $state.go('successfulSignup', { reloadUrl });
            }
          });
      } else if ($stateParams.targetUrl) {
        $state.go('successfulSignup', {
          setStorage: true,
          reloadUrl: $stateParams.targetUrl,
          referrer: $stateParams.referrer,
        });
      } else {
        let reloadUrl = `/${account.username}?welcome`;
        if (account.email) {
          reloadUrl += '&verifyEmail';
        }
        if (account.enabled && account.ageCheckViaBookCode) {
          AeroDialogService.showDialog({
            icon: 'fa fa-comment-exclamation',
            iconClass: 'aero-alert',
            title: $translate.instant('ageCheckDialog_header'),
            detail: $translate.instant('ageCheckDialog_description'),
            showSecondary: false,
            primaryLabel: $translate.instant('button_ok'),
            onPrimary: () => {
              $state.go('successfulSignup', { reloadUrl });
            },
          });
        } else {
          $state.go('successfulSignup', { reloadUrl });
        }
      }
    } else {
      // If a target url is provided, use it.  Otherwise, load the user's profile page, but don't show welcome or
      // verify email alert since this isn't a new account.
      if ($stateParams.targetUrl) {
        redirectToUrl();
      } else {
        // eslint-disable-next-line no-param-reassign
        $window.location.href = `/${account.username}`;
      }
    }
  };

  /**
   * This Method redirect user to targetUrl after successful authentication.
   * It also set 'isAuthorized' property in localstorage if targetUrl is for like page.
   *
   */
  function redirectToUrl() {
    if ($stateParams.targetUrl.startsWith('/u/')) {
      localStorage.setItem('isAuthorized', 'isAuthorized');
    }
    // eslint-disable-next-line no-param-reassign
    $window.location.href = $stateParams.targetUrl;
  }

  function shouldTrackIncompleteSignup() {
    return !that.submitAttempted
      && !that.incompleteSignupSent
      && !!that.signUpForm
      && that.signUpForm.$dirty;
  }

  function buildIncompleteSignupPayload() {
    return {
      mode: that.mode,
      subscribeMode: that.subscribeMode,
      position: that.form.position || null,
      hasEmail: !!that.form.email,
      hasUsername: !!that.form.username,
      hasFirstName: !!that.form.firstName,
      hasLastName: !!that.form.lastName,
      hasInstitutionName: !!that.form.institutionName,
      hasGrade: !!that.form.grade,
      hasDateOfBirth: !!that.form.dateOfBirth,
      orgTokenPresent: !!that.organizationConnectionToken,
    };
  }

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`))
      ?.split('=')[1];
  }

  function sendIncompleteSignup() {
    if (!shouldTrackIncompleteSignup()) {
      return;
    }

    that.incompleteSignupSent = true;
    const payload = buildIncompleteSignupPayload();
    const jsonPayload = JSON.stringify(payload);

    if ($window.fetch) {
      const xsrfToken = getCookie('XSRF-TOKEN');

      $window.fetch(incompleteSignupEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-xsrf-token': xsrfToken,
        },
        credentials: 'same-origin',
        keepalive: true,
        body: jsonPayload,
      }).catch(() => {});
      return;
    }

    Restangular.all('accounts').customPOST(payload, 'incomplete-signup');
  }

  this.submit = function submit() {
    that.submitAttempted = true;
    const accountDTO : any = {
      username: that.form.username,
      email: that.form.email,
      position: that.form.position,
      country: that.form.country?.value,
      language: $translate.getLanguage(),
      dateOfBirth: that.inputDateInMillis,
      zipCode: that.form.zipCode,
      secretQuestion: that.form.secretQuestion,
      marketingOptIn: that.marketingOptIn,
      termsOfUseCheckbox: that.form.agreement,
      prepaidCode: that.form.prepaidCode,
    };

    if (that.form.grade) {
      accountDTO.gradeLevel = that.form.grade;
    }

    if (that.form.ReCaptchaResponse) {
      accountDTO.reCaptchaResponse = that.form.ReCaptchaResponse;
    }

    if (that.organizationConnectionToken) {
      accountDTO.orgToken = that.organizationConnectionToken;
    }

    switch (that.mode) {
      case 'signUpGoogle':
        accountDTO.connection = {
          type: 'google',
        };
        break;
      case 'signUpMicrosoft':
        accountDTO.connection = {
          type: 'mo365',
        };
        break;
      case 'signUpClever':
        accountDTO.connection = {
          type: 'clever',
        };
        break;
      case 'signUpClassLink':
        accountDTO.connection = {
          type: 'classLink',
        };
        break;
      case 'default':
        accountDTO.firstName = that.form.firstName ? that.form.firstName.trim() : '';
        accountDTO.lastName = that.form.lastName ? that.form.lastName.trim() : '';
        accountDTO.displayName = (`${accountDTO.firstName} ${accountDTO.lastName}`).substring(0, 72).trim();
        accountDTO.connection = {
          type: 'password',
          password: that.form.password,
        };
        break;
    }

    // Add the institution name to the accountDTO here regardless if it's undefined or has a value.
    accountDTO.institutionName = that.form.institutionName;

    const redirectUrl = ($stateParams.targetUrl) ? $stateParams.targetUrl : `/${that.form.username}`;

    // We currently don't support prepaidCodes, only promoCodes, so we don't use the prepaidCode parameter
    // for now, and instead just use the normal redirect path.
    //    if (that.subscribeMode === 'free' && that.form.prepaidCode{
    //      accountDTO.prepaidCode = that.form.prepaidCode;
    //      $stateParams.targetUrl = redirectUrl + '?welcome=true';
    //    } else
    if (that.subscribeMode === 'buy' && that.form.position !== 'Educator') {
      // eslint-disable-next-line no-param-reassign
      $stateParams.targetUrl = '/b/planlist';
    } else if (that.subscribeMode === 'tryit60') {
      // Double-check the institutionName because they could be a student signing up for tryit60,
      // which means they don't qualify for the "if statement" right above this if-else conditionals.
      accountDTO.trialDays = 60;
      // eslint-disable-next-line no-param-reassign
      $stateParams.targetUrl = `${redirectUrl}?trial=true`;
    } else if (that.subscribeMode === 'tryit180') {
      accountDTO.trialDays = 180;
      // eslint-disable-next-line no-param-reassign
      $stateParams.targetUrl = `${redirectUrl}?trial=true`;
    }

    if (process.env.DEVTOOLS_ENABLED) {
      accountDTO.testTrial = this.isTestTrial;
    }

    BulbBusyService.showBusyDuring(
      Restangular.all('accounts').post(accountDTO).then((account) => {
        that.handleSuccessfulSignUp(account, true);
      }, (error) => {
        if (error.status === 400 && error.data.developerMessage === 'validation_email_org_domain') {
          RecordEventService.recordEvent('email_signup_prohibited', 'signup', 'org_email_domain');
          return AeroDialogService.showDialog({
            translationScope: 'aeroDialog',
            icon: 'fa fa-exclamation-triangle',
            iconClass: 'aero-alert',
            title: $translate.instant('modal_oops_title'),
            detail: $translate.instant('email_signup'),
            showSecondary: false,
            primaryLabel: $translate.instant('button_ok'),
          });
        }
        if (error.data.errorMap) {
          // allow the form controller to handle field validation errors:
          $scope.signUpForm.handleRemoteErrors(error);
        } else {
          BulbErrorService.showError(null, error);
        }
      }),
    );
  };

  this.connect = function connect() {
    that.signInUnsuccessful = false;

    const body = {
      usernameOrEmail: that.form.usernameOrEmail,
      password: that.form.password,
    };

    BulbBusyService.showBusyDuring(
      Restangular.all('accounts').customPOST(body, 'connect').then((account) => {
        that.handleSuccessfulSignUp(account, false);
      }, (error) => {
        if (error.data.errorMap) {
          // allow the form controller to handle field validation errors:
          $scope.signUpForm.handleRemoteErrors(error);
        } else if (error.data && error.data.developerMessage === 'account_already_connected') {
          BulbModalService.show({
            titleCode: 'account_connection_info_title',
            bodyCode: 'account_already_connected',
            showOkButton: false,
            showCancelButton: false,
          });
        } else if (error.data && error.data.developerMessage === 'sign_in_unsuccessful') {
          // FUTURE : this might be better tied in with the form validation directive/errors,
          // but it was simpler to do this way for now.
          that.signInUnsuccessful = true;
        } else {
          BulbErrorService.showError(null, error);
        }
      }),
    );
  };

  this.signUpWithGoogle = function signUpWithGoogle() {
    const targetUrlParam = $stateParams.targetUrl ? `&targetUrl=${encodeURIComponent($stateParams.targetUrl)}` : '';
    const subscribeModeParam = that.subscribeMode !== 'free' ? `&subscribeMode=${that.subscribeMode}` : '';
    const orgTokenParam = that.organizationConnectionToken ? `&orgToken=${that.organizationConnectionToken}` : '';
    const prepaidCodeParam = that.form.prepaidCode ? `&prepaidCode=${that.form.prepaidCode}` : '';
    // eslint-disable-next-line no-param-reassign
    $window.location.href = `/b/auth/google?entryMode=sign-up${subscribeModeParam
    }${targetUrlParam}${orgTokenParam}${prepaidCodeParam}`;
  };

  this.signUpWithMicrosoft = function signUpWithMicrosoft() {
    const targetUrlParam = $stateParams.targetUrl ? `&targetUrl=${encodeURIComponent($stateParams.targetUrl)}` : '';
    const subscribeModeParam = that.subscribeMode !== 'free' ? `&subscribeMode=${that.subscribeMode}` : '';
    const orgTokenParam = that.organizationConnectionToken ? `&orgToken=${that.organizationConnectionToken}` : '';
    const prepaidCodeParam = that.form.prepaidCode ? `&prepaidCode=${that.form.prepaidCode}` : '';
    // eslint-disable-next-line no-param-reassign
    $window.location.href = `/b/auth/microsoft?entryMode=sign-up${subscribeModeParam
    }${targetUrlParam}${orgTokenParam}${prepaidCodeParam}`;
  };

  this.signUpWithClever = function signUpWithClever() {
    const targetUrlParam = $stateParams.targetUrl ? `&targetUrl=${encodeURIComponent($stateParams.targetUrl)}` : '';
    const subscribeModeParam = `&subscribeMode=${that.subscribeMode}`;
    const orgTokenParam = that.organizationConnectionToken ? `&orgToken=${that.organizationConnectionToken}` : '';
    const prepaidCodeParam = that.form.prepaidCode ? `&prepaidCode=${that.form.prepaidCode}` : '';
    RecordEventService.recordEvent('clever_signup', 'signup_event');
    // eslint-disable-next-line no-param-reassign
    $window.location.href = `/b/auth/clever?entryMode=sign-up${subscribeModeParam
    }${targetUrlParam}${orgTokenParam}${prepaidCodeParam}`;
  };

  /**
   * Function to toggle state of marketing opt in
   * Called on-click of bulb-marketing-checkbox
   */
  this.toggleMarketing = function toggleMarketing() {
    this.marketingOptIn = !this.marketingOptIn;
  };

  this.showConnectionInfo = function showConnectionInfo(event) {
    const modalOptions = {
      titleCode: 'account_connection_info_title',
      templateUrl: 'connectioninfo.nested',
      showOkButton: false,
      showCancelButton: false,
      focusAfterClosed: event.currentTarget,
    };

    BulbModalService.show(modalOptions);
  };

  /**
   * ReCaptcha call back to set the response token in the form.
   * @param res response token from ReCaptcha
   * @returns null
   */
  this.reCaptchaCallback = function reCaptchaCallback(res) {
    // $timeout does a safe $apply to update the scope since the reCaptcha widget is out of the "scope".
    $timeout(() => {
      that.form.ReCaptchaResponse = res;
    });
  };
  // Makes the callback global to the window so reCaptcha has access to it.
  // eslint-disable-next-line no-param-reassign
  $window.reCaptchaCallback = this.reCaptchaCallback;

  $scope.$watch('signUpCtrl.form.position', (newPosition, oldPosition) => {
    // Emit am event so that we can re-run the field validation:
    $scope.$broadcast('positionChange');
    // Delete any form data we have gathered if the position type is changed such that that data is
    // no longer necessary or applicable.
    if (newPosition !== oldPosition && oldPosition === 'Student') {
      delete that.form.dateOfBirth;
      delete that.inputDateInMillis;
    }
  });

  $window.addEventListener('pagehide', sendIncompleteSignup);

  $scope.$on('$destroy', () => {
    sendIncompleteSignup();
    $window.removeEventListener('pagehide', sendIncompleteSignup);
  });
}
